import { AutoMap } from "@automapper/classes";
import { MaterielAdductionDTO } from "./materiel-adduction.dto";
import { PrelevementAirDTO } from "./prelevement-air.dto";

export class MesureAdductionDTO {

    @AutoMap()
    code!: string;

    @AutoMap()
    date!: string;

    @AutoMap()
    localisation!: string;

    @AutoMap()
    samplingID!: number;

    @AutoMap()
    observation!: string;

    @AutoMap()
    appareilMesure!: string;

    /** 3 Max  */
    @AutoMap(() => [MaterielAdductionDTO])
    materielAdductionAirList: MaterielAdductionDTO[] = [];

    /** 5 Max  */
    @AutoMap(() => [PrelevementAirDTO])
    prelevementAirList: PrelevementAirDTO[] = [];

    @AutoMap()
    isCancelled: boolean = false;
}